export const BAG_CLOSING_ANIMATION_LENGTH = 1000;
